export default __webpack_public_path__ + "static/media/logo.173944e0.png";